module.exports = __webpack_public_path__ + "img/ring_PEWAG_M8W.161d6774.png";